import { CardElement } from '@stripe/react-stripe-js';
import { type Stripe, type StripeElements, type TokenResult } from '@stripe/stripe-js';

/**
 * Shared tokenization helper. `stripe.createToken()` requires the mounted `CardElement`
 * instance; `elements.getElement` returns `null` before the element has mounted.
 */
export const createCardToken = ({
  stripe,
  elements,
}: {
  stripe: Stripe;
  elements: StripeElements;
}): Promise<TokenResult> => {
  const cardElement = elements.getElement(CardElement);

  if (!cardElement) {
    throw new Error('Card element is not mounted');
  }

  return stripe.createToken(cardElement);
};
